module.exports = __webpack_public_path__ + "media/images/map/2-b217f2e2054912ca32ce530339c16516.png";